import {
  ConcreteMaterialFilenameTemplateItem,
  ConcreteMixDesignFilenameTemplateItem,
  ConcretePlacementFilenameTemplateItem,
  ConcreteTestFilenameTemplateItem,
  ConcreteTestSetFilenameTemplateItem,
  ConcreteTestSetRelationFilenameTemplateItem,
} from '../classes/concrete'
import { dateOptions, defaultsTo } from '../utils'

export const ConcreteTestSubId = new ConcreteTestFilenameTemplateItem({
  id: 'e4a0a379-259f-4a39-adc3-d98d168669d1',
  name: 'Test Sub ID',
  property: 'testSubId',
  help: 'Test Sub ID from Concrete Test table',
  exampleValue: 'PLA-0014-A',
})

export const ConcreteFieldNumber = new ConcreteTestFilenameTemplateItem({
  id: '9bbe03d8-0918-417d-a531-2f2ee4bd0069',
  name: 'Field Number',
  property: 'fieldNumber',
  help: `Manual Cylinder Number from Concrete Test table. ${defaultsTo({
    name: 'Manual Cylinder Number',
    property: 'Test Sub ID',
  })}`,
  exampleValue: 'PLA-0014',
})

export const ConcretePlacementId = new ConcretePlacementFilenameTemplateItem({
  id: '2c63fdbd-428c-46ae-ae6c-2a04613e92d2',
  name: 'Placement ID',
  property: 'placementId',
  help: 'Placement ID from Concrete Placement table',
  exampleValue: 'PLA-00140-P1',
})

export const ConcretePlacementDate = new ConcreteTestSetFilenameTemplateItem({
  id: '71ccacdf-0459-44f8-9b84-9db6e15105b1',
  name: 'Placement Date',
  property: 'placementDate',
  ...dateOptions({
    name: 'Placement Date',
    tableNameSingular: 'Concrete Test Set',
  }),
})

export const ConcreteMixDesign = new ConcreteMixDesignFilenameTemplateItem({
  id: '2bf3a469-3282-4fc2-ae59-f42c440fef4f',
  name: 'Mix Design',
  property: 'mixDesignNumber',
  help: 'Mix Design Number from Concrete Mix Design table',
  exampleValue: 'A6505A',
})

export const ConcreteClientMixDesign =
  new ConcreteMixDesignFilenameTemplateItem({
    id: '625de545-ca76-45e0-a20b-253a1ab3159d',
    name: 'Client Mix Design Number',
    property: 'clientDesignNumber',
    help: 'Client Design Number from Concrete Mix Design table',
    exampleValue: 'A6505A',
  })

export const ConcreteClassification = new ConcreteMixDesignFilenameTemplateItem(
  {
    id: 'b9ec170a-3942-4645-851d-3291fa5f847c',
    name: 'Classification',
    property: 'class',
    help: 'Class from Concrete Mix Design table',
    exampleValue: 'AA(AE)',
  }
)

export const ConcretePlacementType = new ConcreteMaterialFilenameTemplateItem({
  id: 'd06236ac-f028-43f7-b7c8-9188056d9e85',
  name: 'Placement Type',
  property: 'placementType',
  help: 'Placement Type from Concrete Materials table',
  exampleValue: 'PCCP-Machine Pour',
})

export const ConcreteShortName = new ConcreteMaterialFilenameTemplateItem({
  id: 'ca13c44a-5338-47cd-a1b9-9fd658be2969',
  name: 'Placement Type Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Concrete Materials table',
  exampleValue: 'PCCP',
})

export const ConcreteTestSetId = new ConcreteTestSetFilenameTemplateItem({
  id: '0f21ce17-0fb0-4b98-abf5-6ff1e4d0f380',
  name: 'Test Set ID',
  property: 'testSetId',
  help: 'Test Set ID from Concrete Test Set table',
  exampleValue: 'PLA-0014',
})

export const ConcretePlacementIds =
  new ConcreteTestSetRelationFilenameTemplateItem({
    id: '5ddc34c2-7b06-4649-9885-4d3d47c9f51c',
    name: 'Placement IDs',
    property: 'concretePlacements',
    subProperty: 'placementId',
    help: 'A list of Placement IDs from Concrete Placement table, joined with an underscore',
    exampleValue: 'PLA-00140-P1',
  })

export const ConcreteFieldNumbers =
  new ConcreteTestSetRelationFilenameTemplateItem({
    id: 'e8a22592-055c-4722-8df0-ee2f4128dd49',
    name: 'Field Numbers',
    property: 'concreteTests',
    subProperty: 'fieldNumber',
    help: `A list of Manual Cylinder Numbers from Concrete Test table, joined with an underscore. ${defaultsTo(
      {
        name: 'Manual Cylinder Number',
        property: 'Test Sub ID',
      }
    )} for each Manual Cylinder Number`,
    exampleValue: 'PLA-0014_PLA-0015_PLA-0016',
  })

export const ConcreteTestSubIds =
  new ConcreteTestSetRelationFilenameTemplateItem({
    id: '91877fc8-a6dc-4df6-aade-fc5f8c230181',
    name: 'Test Sub IDs',
    property: 'concreteTests',
    subProperty: 'testSubId',
    help: `A list of Test Sub IDs from Concrete Test table, joined with an underscore`,
    exampleValue: 'PLA-0014-A_PLA-0014-B_PLA-0014-C',
  })

export type ConcreteFilename =
  | typeof ConcreteTestSubId
  | typeof ConcreteFieldNumber
  | typeof ConcretePlacementId
  | typeof ConcretePlacementDate
  | typeof ConcreteMixDesign
  | typeof ConcreteClientMixDesign
  | typeof ConcreteClassification
  | typeof ConcretePlacementType
  | typeof ConcreteShortName
  | typeof ConcreteTestSetId
  | typeof ConcretePlacementIds
  | typeof ConcreteFieldNumbers
  | typeof ConcreteTestSubIds
